import { useTheme } from '@mui/material';
const useHistoryListStyles = () => {
    const theme = useTheme();
    const headerHeight = '48px';
    const bottomNavigationHeight = '56px';
    const sectionHeaderHeight = '50px';
    return {
        containerStyles: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            p: 0,
            background: theme.palette.background.paper
        },
        contentContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingBottom: 1,
            height: `calc(100dvh - ${headerHeight} - ${bottomNavigationHeight} - ${sectionHeaderHeight})`,
            overflowY: 'auto'
        }
    };
};
export default useHistoryListStyles;
